export  enum  MessageTypeEnum {
    OrderLogsMessageType  =  17
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/message-type.enums.ts